module.exports = __webpack_public_path__ + "media/images/pc/top/confetti-107068dbcef5cdf8d64c81f819a32505.png";